document.addEventListener("click", function (e) {
  const link = e.target.closest('a[href="#floating-cart"]');
  if (!link) return;

  e.preventDefault(); // stop anchor jump/scroll
  
  const btn = document.querySelector('#floating-cart');
  if (btn) btn.click();
});
